const LAZY_VIDEO_SELECTOR = 'video[data-lazy-video]';
const ROOT_MARGIN = '200px 0px';

const loadVideo = (video, observer = null) => {
    if (!video.matches(LAZY_VIDEO_SELECTOR)) return;

    observer?.unobserve(video);

    video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
    });

    video.removeAttribute('data-lazy-video');
    video.load();

    if (video.autoplay) {
        video.play().catch(() => {});
    }
};

export const initLazyVideos = () => {
    const videos = document.querySelectorAll(LAZY_VIDEO_SELECTOR);

    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
        videos.forEach(video => loadVideo(video));
        return;
    }

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadVideo(entry.target, observer);
                }
            });
        },
        {
            rootMargin: ROOT_MARGIN,
            threshold: 0.01,
        }
    );

    videos.forEach(video => observer.observe(video));
};
